import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadAssessment } from "../../lib/api/assessment";
import { AssessmentDetailForm } from "../../components/assessment/AssessmentDetailForm";
import { EmptyBlank } from "../../components/common";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [assessment, setAssessment] = useState();

  const requestLoadAssessment = useCallback(async () => {
    const { data } = await loadAssessment({ id: id });
    //console.log(data);
    setAssessment(data);
  }, [id]);

  useEffect(() => {
    requestLoadAssessment();
  }, [requestLoadAssessment]);

  const handelEdit = (e) => {
    //console.log("e.target => ", e.target);
    const weekId = id;
    navigate(`/assessments/${weekId}/edit`, {
      state: { [e.target.name]: e.target.value },
    });
  };

  return (
    <div>
      <Container fluid="md">
        {assessment ? (
          <AssessmentDetailForm
            assessment={assessment}
            handelEdit={handelEdit}
          />
        ) : undefined}
        <EmptyBlank />
      </Container>
    </div>
  );
};

export default Detail;
